export default "__VITE_ASSET__CE8T23VO__"